import Vue from "vue";

const legacyConfig = {
    slider: {
        "left": "poi",
        "right": "fov"
    },
    assets: {}
};

class ConfigHandler {
    constructor() {
        this.selected = null;
        this.assetUrl = process.env.VUE_APP_ASSET_URL;
        this.apiUrl = process.env.VUE_APP_API_URL;
    }

    selectAircraft(cockpitData) {
        this.selected = cockpitData.aircraftName.toUpperCase();
        this.config =  Object.assign({}, cockpitData.room, legacyConfig);
        this.config.handbookURL = cockpitData.room.handbook ?
            cockpitData.room.handbook.url : undefined;

        this.config.handbooks = [];

        if(cockpitData.room.handbooks){
            for(const key in cockpitData.room.handbooks){
                if(cockpitData.room.handbooks[key]){
                    this.config.handbooks.push({key, url: cockpitData.room.handbooks[key].url})
                }
            }
        }


        this.procedures = cockpitData.procedures
        this.poi = {}
        cockpitData.spots.forEach(spot => {
            this.poi[spot.id] = spot;
        })
        return this;
    }

    getPOI(name){
        if(!this.poi[name]){
            throw new Error('POI "'+name+'" not found! Available: ' + Object.keys(this.poi).join(','))
        }
        return this.poi[name];
    }

    getConfig() {
        return this.config;
    }

    getAsset(assetName){
        Vue.$log.error('getAsset called for ' + assetName + ' but no assets exist since API rework')
        if(!this.config.assets[assetName]) return undefined;
        return this.assetUrl + '/' + this.config.assets[assetName];
    }

    getButton(name){
        if(!this.config.assets.btn_dir){
            throw new Error('Button Directory not defined but called')
        }

        return this.assetUrl + "/" + this.config.assets.btn_dir + name + ".png";
    }

    find(aircraft){
        Vue.$log.error('Aircrafts Const Array is removed, need to use API functions instead...')
        return null;
    }

    getMeshPath(filename) {
        if(this.config.mesh && this.config.mesh[filename])
            return this.assetUrl + this.preprendSlash(this.config.mesh[filename]);
        return `${this.assetUrl}/airplanes/${this.selected}/mesh/${filename}.glb`;
    }

    preprendSlash(path){
        return '/' + path.replace(/^\//, '')
    }
}

export const settings = {
    START_SLIDER_FOV: 250,
    START_SLIDER_POI: 100,
    _FOV_START: 70,
    _FOV_MIN: 30,
    _FOV_MAX: 100,
    _SLIDER_RES: 500,
    DELAY_LOADING_SCREEN_COCKPIT: 1000,
    TWEEN_MAX_TIME: 1500,
    TWEEN_MIN_TIME: 300,
    DEFAULT_LOOKAT_POS: [5000, -1500, 0],
    MARKER_PADDING_LEFT: 25,
    MARKER_PADDING_TOP: 8,
    DEBUGVISIBLE: false,
    ANIMATION_TIME_THUMB_UP_DOWN: 700,
    MARKER_LINE_COLOR: '#ffffff',
    SECONDARY_COLOR: '#f9ba00',
    HIGHLIGHT_COLOR: '#f9ba00',
    INFOPOINT_SCALE: 300,
    INFOPOINT_MAX_TRANSPARENCY: 0.6,
    HIDEINFOPOINTAFTERHOVER: 500
};

export const LufthansaColors = {
    yellow: '#ffad00',
    blue_deep: '#05164d',
    text_blue: '#05164D',
    text_grey: '#666666',
    blue_breeze1: '#849AC2',
    blue_breeze2: '#6E8BB7',
    white: '#ffffff',
    grey1: '#f5f5f5',
    grey2: '#ebebeb',
    interaction: '#52627C',
    interaction_hover: '#414E63',
    button_primary: '#FFAD00',
    button_primary_hover: '#FFBD32',
    button_secondary: '#05164D',
    sky_blue_1:'#3588C9',
    sky_blue_2:'#75BCE9',
    sky_blue_3:'#CFEBFC',
    pidgeon_blue_1:'#8BB4C9',
    pidgeon_blue_2:'#BBD9E5',
    pidgeon_blue_3:'#DDEBF1',
}

export const aircraftConfig = new ConfigHandler();
